export const rosPermissions = 'Users';

export const WaitlinesPermissions = 'Waitlines';
export const o2oPermissions = 'O2O';
export const patchPermissions = 'Patch';
export const posReasonPermissions = 'POSReasons';
export const printerPortalPermissions = 'PrinterManagement';
export const rapPermissions = 'RAP';
export const readOnlyPermissions = 'ReadOnly';
export const registerLevelTrackingPermissions = 'RLT';
export const registerLevelTrackingPermissionsReadOnly = 'RLT.ReadOnly';
export const scsPermissions = 'SCS';
export const slsPermissions = 'SLS';
export const storeServicesPermissions = 'Zones';
export const trafficPermissions = 'Traffic';
export const zonesPermissions = 'Zones';
export const taxIdentifierPermissions = 'TaxIdentifier';
export const storeHierarchyPermissions = 'StoreHierarchy';
export const ccmPermissions = 'CCM';

export const frameUser = [
  'App.RetailOperations.Users',
  'Application.RISE.Operations.Users.DevicesAndWaitlines',
  'App.RetailOperations.Users.O2OCapabilities',
  'App.RCF.ROS.Users.POSReasonsAdmin.CRUD',
  'Application.RISE.Operations.Users.Patch',
  'Application.RISE.Operations.Users.PrinterManagement',
  // frameUser values must match testGroups values to grant anything in NODE_ENV=development,
  // since getPermissionsToGroups() returns testGroups in all non-prod envs.
  'App.Retail-DevOps.Test',
  /* do not be a member of read only unless you want to have read only access to scs */
  // 'Application.RISE.Operations.Users.ReadOnly',
  'App.RetailOperations.Users.RLT',
  // 'App.RetailOperations.Users.RLT.ReadOnly',
  'Application.RISE.Operations.Users.SCS',
  'Application.RISE.Operations.Users.SCS.ALL',
  /* these other SCS groups are redundant if you have SCS.ALL */
  // 'Application.RISE.Operations.Users.SCS.ASSIST',
  // 'Application.RISE.Operations.Users.SCS.LINK',
  // Application.RISE.Operations.Users.SCS.RL,
  // 'Application.RISE.Operations.Users.SCS.RISE',
  // 'Application.RISE.Operations.Users.SCS.SFS',
  // 'Application.RISE.Operations.Users.SCS.SIM',
  'Application.RISE.Operations.Users.Traffic',
  'App.RetailOperations.Users.TaxIdentifiers',
  'Application.RISE.Operations.Users.Zones',
  'Application.RISE.AdminUI.Users',
  'Application.RISE.AdminUI.Owner',
  'App.RISE.AdminUI.Users.SLS.ReadOnly',
  'Application.RISE.AdminUI.Users.SLS.ALL',
  'Application.RISE.AdminUI.Users.SLS.IslandPacific',
  /* currently commented out because the Just Enough section has a bug in it */
  // 'Application.RISE.AdminUI.Users.SLS.JustEnough',
  /* these other SLS region groups are redundant if you have SLS.ALL */
  // 'Application.RISE.AdminUI.Users.SLS.AMER',
  // 'Application.RISE.AdminUI.Users.SLS.APLA',
  // 'Application.RISE.AdminUI.Users.SLS.EMEA',
  // 'Application.RISE.AdminUI.Users.SLS.GC',
  // 'Application.RISE.AdminUI.Users.SLS.NA',
  'App.RBH.AdminUI.Users.SLS.CMP',

  // ////////////////////////////////////////////////
  // START Store Hierarchy Groups
  // ////////////////////////////////////////////////

  // === App Tab group ===

  'App.RetailOperations.Users.StoreHierarchy',

  // == Global admin
  'App.StoreHierarchy.GlobalAdmin',

  // == Delete group ==
  // 'App.StoreHierarchy.DeletePermission',

  // === Read-Only groups ===

  // 'App.StoreHierarchy.ConverseAPLA-ReadOnly',
  // 'App.StoreHierarchy.ConverseEMEA-ReadOnly',
  // 'App.StoreHierarchy.ConverseGC-ReadOnly',
  // 'App.StoreHierarchy.ConverseNA-ReadOnly',
  // 'App.StoreHierarchy.NikeAPLA-ReadOnly',
  // 'App.StoreHierarchy.NikeEMEA-ReadOnly',
  // 'App.StoreHierarchy.NikeGC-ReadOnly',
  // 'App.StoreHierarchy.NikeNA-ReadOnly',

  // === Read-Write groups ===

  // 'App.StoreHierarchy.ConverseAPLA',
  // 'App.StoreHierarchy.ConverseEMEA',
  // 'App.StoreHierarchy.ConverseGC',
  // 'App.StoreHierarchy.ConverseNA',
  // 'App.StoreHierarchy.NikeAPLA',
  // 'App.StoreHierarchy.NikeEMEA',
  // 'App.StoreHierarchy.NikeGC',
  // 'App.StoreHierarchy.NikeNA',

  // ////////////////////////////////////////////////
  // END Store Hierarchy Groups
  // ////////////////////////////////////////////////

  'App.RetailOperations.CCM.Users.Admin',
  'App.RetailOperations.CCM.Users',
];

const getPermissionsToGroups = () => {
  const productionGroups = {
    AdminO2O: 'App.RetailOperations.SwooshQR.O2OCapabilities.Admin',

    CCM: 'App.RetailOperations.CCM.Users',
    'CCM.ADMIN': 'App.RetailOperations.CCM.Users.Admin',
    O2O: 'App.RetailOperations.Users.O2OCapabilities',
    Patch: 'Application.RISE.Operations.Users.Patch',
    POSReasons: 'App.RCF.ROS.Users.POSReasonsAdmin.CRUD',
    PrinterManagement: 'Application.RISE.Operations.Users.PrinterManagement',
    // Prod-only AD groups. The pre-prod `retailauth` lambda authorizes against
    // App.Retail-DevOps.Test (see testGroups.RAP below); the prod lambda
    // authorizes against Support/Engineer via USER_GROUP_SUPPORT / USER_GROUP_ENGINEER
    // env vars in rcffus-ros-backend. Backend checks any-of, so array ordering is cosmetic.
    RAP: ['App.Retail-DevOps.Support', 'App.Retail-DevOps.Engineer'],
    ReadOnly: 'Application.RISE.Operations.Users.ReadOnly',
    RLT: 'App.RetailOperations.Users.RLT',
    'RLT.ReadOnly': 'App.RetailOperations.Users.RLT.ReadOnly',
    SCS: 'App.RetailOperations.Users.SCS.Prod',
    'SCS.ALL': 'App.RetailOperations.Users.SCS.ALL.Prod.Editor',
    'SCS.ALL.ReadOnly': 'App.RetailOperations.Users.SCS.ALL.Prod',
    'SCS.ASSIST': 'App.RetailOperations.Users.SCS.ASSIST.Prod.Editor',
    'SCS.ASSIST.ReadOnly': 'App.RetailOperations.Users.SCS.ASSIST.Prod',
    'SCS.LINK': 'App.RetailOperations.Users.SCS.LINK.Prod.Editor',
    'SCS.LINK.ReadOnly': 'App.RetailOperations.Users.SCS.LINK.Prod',
    'SCS.NPOS': 'App.RetailOperations.Users.SCS.NPOS.Prod.Editor',
    'SCS.NPOS.ReadOnly': 'App.RetailOperations.Users.SCS.NPOS.Prod',
    'SCS.OTHER': 'App.RetailOperations.Users.SCS.OTHER.Prod.Editor',
    'SCS.OTHER.ReadOnly': 'App.RetailOperations.Users.SCS.OTHER.Prod',
    'SCS.POS': 'App.RetailOperations.Users.SCS.1POS.Prod.Editor',
    'SCS.POS.ReadOnly': 'App.RetailOperations.Users.SCS.1POS.Prod',
    'SCS.PROMOTE': 'App.RetailOperations.Users.SCS.PromoteApp.Prod.Editor',
    'SCS.PROMOTE.ReadOnly': 'App.RetailOperations.Users.SCS.PromoteApp.Prod',
    'SCS.RISE': 'App.RetailOperations.Users.SCS.RISE.Prod.Editor',
    'SCS.RISE.ReadOnly': 'App.RetailOperations.Users.SCS.RISE.Prod',
    'SCS.RL': 'App.RetailOperations.Users.SCS.RL.Prod.Editor',
    'SCS.RL.ReadOnly': 'App.RetailOperations.Users.SCS.RL.Prod',
    'SCS.SCO': 'App.RetailOperations.Users.SCS.SCO.Prod.Editor',
    'SCS.SCO.ReadOnly': 'App.RetailOperations.Users.SCS.SCO.Prod',
    'SCS.SFS': 'App.RetailOperations.Users.SCS.SFS.Prod.Editor',
    'SCS.SFS.ReadOnly': 'App.RetailOperations.Users.SCS.SFS.Prod',
    'SCS.SIM': 'App.RetailOperations.Users.SCS.SIM.Prod.Editor',
    'SCS.SIM.ReadOnly': 'App.RetailOperations.Users.SCS.SIM.Prod',
    'SCS.TRACK': 'App.RetailOperations.Users.SCS.TRACK.Prod.Editor',
    'SCS.TRACK.ReadOnly': 'App.RetailOperations.Users.SCS.TRACK.Prod',

    SLS: 'Application.RISE.AdminUI.Users',
    'SLS.ALL': 'Application.RISE.AdminUI.Users.SLS.ALL',
    'SLS.AMER': 'Application.RISE.AdminUI.Users.SLS.AMER',
    'SLS.APLA': 'Application.RISE.AdminUI.Users.SLS.APLA',
    'SLS.ASIA_PACIFIC_LATIN_AMERICA': 'Application.RISE.AdminUI.Users.SLS.APLA',
    'SLS.EMERGING_MARKETS': 'Application.RISE.AdminUI.Users.SLS.AMER',
    'SLS.EU': 'Application.RISE.AdminUI.Users.SLS.EMEA',
    'SLS.EUROPE_MIDDLE_EAST_AFRICA': 'Application.RISE.AdminUI.Users.SLS.EMEA',
    'SLS.GC': 'Application.RISE.AdminUI.Users.SLS.GC',
    'SLS.GREATER_CHINA': 'Application.RISE.AdminUI.Users.SLS.GC',
    'SLS.IP': 'Application.RISE.AdminUI.Users.SLS.IslandPacific',
    'SLS.JE': 'Application.RISE.AdminUI.Users.SLS.JustEnough',

    'SLS.Media.ALL': 'App.RetailOperations.Users.SLS.Media.All',
    'SLS.Media.ASIA_PACIFIC_LATIN_AMERICA': 'App.RetailOperations.Users.SLS.Media.APLA',
    'SLS.Media.EUROPE_MIDDLE_EAST_AFRICA': 'App.RetailOperations.Users.SLS.Media.EMEA',
    'SLS.Media.GREATER_CHINA': 'App.RetailOperations.Users.SLS.Media.GC',
    'SLS.Media.NORTH_AMERICA': 'App.RetailOperations.Users.SLS.Media.NA',

    'SLS.NA': 'Application.RISE.AdminUI.Users.SLS.NA',
    'SLS.NORTH_AMERICA': 'Application.RISE.AdminUI.Users.SLS.NA',
    'SLS.Owner': 'Application.RISE.AdminUI.Owner',
    'SLS.ReadOnly': 'App.RISE.AdminUI.Users.SLS.ReadOnly',

    StoreHierarchy: 'App.RetailOperations.Users.StoreHierarchy',
    TaxIdentifier: 'App.RetailOperations.Users.TaxIdentifiers',
    Traffic: 'Application.RISE.Operations.Users.Traffic',
    Users: 'App.RetailOperations.Users',
    Waitlines: 'Application.RISE.Operations.Users.DevicesAndWaitlines',
    Zones: 'Application.RISE.Operations.Users.Zones',
  };

  const testGroups = {
    AdminO2O: 'App.RetailOperations.SwooshQR.O2OCapabilities.Admin',

    CCM: 'App.RetailOperations.CCM.Users',
    'CCM.ADMIN': 'App.RetailOperations.CCM.Users.Admin',
    O2O: 'App.RetailOperations.Users.O2OCapabilities',
    Patch: 'Application.RISE.Operations.Users.Patch',
    POSReasons: 'App.RCF.ROS.Users.POSReasonsAdmin.CRUD',
    PrinterManagement: 'Application.RISE.Operations.Users.PrinterManagement',
    RAP: 'App.Retail-DevOps.Test',
    ReadOnly: 'Application.RISE.Operations.Users.ReadOnly',
    RLT: 'App.RetailOperations.Users.RLT',
    'RLT.ReadOnly': 'App.RetailOperations.Users.RLT.ReadOnly',

    // For test/dev environment, we are not differentiating between read only and editor groups for SCS, so all permissions will be editable
    SCS: 'Application.RISE.Operations.Users.SCS',
    'SCS.ALL': 'Application.RISE.Operations.Users.SCS.ALL',
    'SCS.ASSIST': 'Application.RISE.Operations.Users.SCS.ASSIST',
    'SCS.LINK': 'Application.RISE.Operations.Users.SCS.LINK',
    'SCS.NPOS': 'App.RISE.Operations.Users.SCS.NPOS',
    'SCS.OTHER': 'App.RetailOperations.Users.SCS.OTHER',
    'SCS.POS': 'App.RetailOperations.Users.SCS.1POS',
    'SCS.PROMOTE': 'App.RetailOperations.Users.SCS.PromoteApp',
    'SCS.RISE': 'Application.RISE.Operations.Users.SCS.RISE',
    'SCS.RL': 'Application.RISE.Operations.Users.SCS.RL',
    'SCS.SCO': 'App.RISE.Operations.Users.SCS.SCO',
    'SCS.SFS': 'Application.RISE.Operations.Users.SCS.SFS',
    'SCS.SIM': 'Application.RISE.Operations.Users.SCS.SIM',
    'SCS.TRACK': 'App.RISE.Operations.Users.SCS.TRACK',

    SLS: 'Application.RISE.AdminUI.Users',
    'SLS.ALL': 'Application.RISE.AdminUI.Users.SLS.ALL',
    'SLS.AMER': 'Application.RISE.AdminUI.Users.SLS.AMER',
    'SLS.APLA': 'Application.RISE.AdminUI.Users.SLS.APLA',
    'SLS.ASIA_PACIFIC_LATIN_AMERICA': 'Application.RISE.AdminUI.Users.SLS.APLA',
    'SLS.EMERGING_MARKETS': 'Application.RISE.AdminUI.Users.SLS.AMER',
    'SLS.EU': 'Application.RISE.AdminUI.Users.SLS.EMEA',
    'SLS.EUROPE_MIDDLE_EAST_AFRICA': 'Application.RISE.AdminUI.Users.SLS.EMEA',
    'SLS.GC': 'Application.RISE.AdminUI.Users.SLS.GC',
    'SLS.GREATER_CHINA': 'Application.RISE.AdminUI.Users.SLS.GC',
    'SLS.IP': 'Application.RISE.AdminUI.Users.SLS.IslandPacific',
    'SLS.JE': 'Application.RISE.AdminUI.Users.SLS.JustEnough',

    'SLS.Media.ALL': 'App.RetailOperations.Users.SLS.Media.All',
    'SLS.Media.ASIA_PACIFIC_LATIN_AMERICA': 'App.RetailOperations.Users.SLS.Media.APLA',
    'SLS.Media.EUROPE_MIDDLE_EAST_AFRICA': 'App.RetailOperations.Users.SLS.Media.EMEA',
    'SLS.Media.GREATER_CHINA': 'App.RetailOperations.Users.SLS.Media.GC',
    'SLS.Media.NORTH_AMERICA': 'App.RetailOperations.Users.SLS.Media.NA',

    'SLS.NA': 'Application.RISE.AdminUI.Users.SLS.NA',
    'SLS.NORTH_AMERICA': 'Application.RISE.AdminUI.Users.SLS.NA',
    'SLS.Owner': 'Application.RISE.AdminUI.Owner',
    'SLS.ReadOnly': 'App.RISE.AdminUI.Users.SLS.ReadOnly',

    StoreHierarchy: 'App.RetailOperations.Users.StoreHierarchy',
    TaxIdentifier: 'App.RetailOperations.Users.TaxIdentifiers',
    Traffic: 'Application.RISE.Operations.Users.Traffic',
    Users: 'App.RetailOperations.Users',
    Waitlines: 'Application.RISE.Operations.Users.DevicesAndWaitlines',
    Zones: 'Application.RISE.Operations.Users.Zones',
  };

  return process.env.NODE_ENV.toLowerCase() === 'production' ? productionGroups : testGroups;
};

// Backward compatibility: export the permissions for the current environment
export const permissionsToGroups = getPermissionsToGroups();

// Role-based tabs show the user's AD-role display name instead of raw AD-group DNs in
// authz messaging; the underlying authorization check is still group-based because the
// Okta token exposes only the `groups` claim. Keys are AD-group names, values are the
// human-readable role names the design asks us to surface.
const groupToRoleDisplayName = {
  'App.Retail-DevOps.Engineer': 'RAP Retail-DevOps Engineer',
  'App.Retail-DevOps.Support': 'RAP Retail-DevOps Support',
  'App.Retail-DevOps.Test': 'RAP Retail-DevOps Test',
};

export const getRolesForPermission = (permission) => {
  const groups = getPermissionsToGroups()[permission];
  if (!groups) return [];
  const groupList = Array.isArray(groups) ? groups : [groups];
  return groupList
    .map((group) => groupToRoleDisplayName[group])
    .filter(Boolean);
};

export const isRoleBasedPermission = (permission) => getRolesForPermission(permission).length > 0;

const getSubGroupUsages = () => {
  const productionUsages = {
    'App.RetailOperations.Users.SCS.1POS.Prod': "View POS team's SCS keys",
    'App.RetailOperations.Users.SCS.1POS.Prod.Editor': "View and edit POS team's SCS keys",
    'App.RetailOperations.Users.SCS.ALL.Prod': 'View all SCS keys',
    'App.RetailOperations.Users.SCS.ALL.Prod.Editor': 'View and edit all SCS keys',
    'App.RetailOperations.Users.SCS.ASSIST.Prod': "View AIC, ASSIST, and NSP team's SCS keys",
    'App.RetailOperations.Users.SCS.ASSIST.Prod.Editor': "View and edit AIC, ASSIST, and NSP team's SCS keys",
    'App.RetailOperations.Users.SCS.LINK.Prod': "View Nike+ LINK team's SCS keys",
    'App.RetailOperations.Users.SCS.LINK.Prod.Editor': "View and edit Nike+ LINK team's SCS keys",
    'App.RetailOperations.Users.SCS.NPOS.Prod': "View NPOS team's SCS keys",
    'App.RetailOperations.Users.SCS.NPOS.Prod.Editor': "View and edit NPOS team's SCS keys",
    'App.RetailOperations.Users.SCS.OTHER.Prod': 'View other SCS keys',
    'App.RetailOperations.Users.SCS.OTHER.Prod.Editor': 'View and edit other SCS keys',
    'App.RetailOperations.Users.SCS.PromoteApp.Prod': "View Promote App's SCS keys",
    'App.RetailOperations.Users.SCS.PromoteApp.Prod.Editor': "View and edit Promote App's SCS keys",
    'App.RetailOperations.Users.SCS.RISE.Prod': "View RISE team's SCS keys",
    'App.RetailOperations.Users.SCS.RISE.Prod.Editor': "View and edit RISE team's SCS keys",
    'App.RetailOperations.Users.SCS.RL.Prod': "View RISE team's RL keys",
    'App.RetailOperations.Users.SCS.RL.Prod.Editor': "View and edit RISE team's RL keys",
    'App.RetailOperations.Users.SCS.SCO.Prod': "View Self Check out team's SCS keys",
    'App.RetailOperations.Users.SCS.SCO.Prod.Editor': "View and edit Self Check out team's SCS keys",
    'App.RetailOperations.Users.SCS.SFS.Prod': "View SFS team's SCS keys",
    'App.RetailOperations.Users.SCS.SFS.Prod.Editor': "View and edit SFS team's SCS keys",
    'App.RetailOperations.Users.SCS.SIM.Prod': "View SIM team's SCS keys",
    'App.RetailOperations.Users.SCS.SIM.Prod.Editor': "View and edit SIM team's SCS keys",
    'App.RetailOperations.Users.SCS.TRACK.Prod': "View Track team's SCS keys",
    'App.RetailOperations.Users.SCS.TRACK.Prod.Editor': "View and edit Track team's SCS keys",
    'Application.RISE.AdminUI.Users.SLS.ALL': 'Add/edit stores in all regions',
    'Application.RISE.AdminUI.Users.SLS.AMER': 'Add/edit stores in the AMER region',
    'Application.RISE.AdminUI.Users.SLS.APLA': 'Add/edit stores in the APLA region',
    'Application.RISE.AdminUI.Users.SLS.EMEA': 'Add/edit stores in the EMEA region',
    'Application.RISE.AdminUI.Users.SLS.GC': 'Add/edit stores in the GC region',
    'Application.RISE.AdminUI.Users.SLS.NA': 'Add/edit stores in the NA region',
  };

  const testUsages = {
    'App.RetailOperations.Users.SCS.1POS': "View and edit POS team's SCS test keys",
    'App.RetailOperations.Users.SCS.OTHER': 'View and edit other SCS test keys',
    'App.RetailOperations.Users.SCS.PromoteApp': "View and edit Promote App's SCS test keys",
    'App.RISE.Operations.Users.SCS.NPOS': "View and edit NPOS team's SCS test keys",
    'App.RISE.Operations.Users.SCS.SCO': "View and edit Self Check out team's SCS test keys",
    'App.RISE.Operations.Users.SCS.TRACK': "View and edit Track team's SCS test keys",
    'Application.RISE.AdminUI.Users.SLS.ALL': 'Add/edit stores in all regions',
    'Application.RISE.AdminUI.Users.SLS.AMER': 'Add/edit stores in the AMER region',
    'Application.RISE.AdminUI.Users.SLS.APLA': 'Add/edit stores in the APLA region',
    'Application.RISE.AdminUI.Users.SLS.EMEA': 'Add/edit stores in the EMEA region',
    'Application.RISE.AdminUI.Users.SLS.GC': 'Add/edit stores in the GC region',
    'Application.RISE.AdminUI.Users.SLS.NA': 'Add/edit stores in the NA region',
    'Application.RISE.Operations.Users.SCS.ALL': 'View and edit all SCS test keys',
    'Application.RISE.Operations.Users.SCS.ASSIST': "View and edit AIC, ASSIST, and NSP team's SCS test keys",
    'Application.RISE.Operations.Users.SCS.LINK': "View and edit Nike+ LINK team's SCS test keys",
    'Application.RISE.Operations.Users.SCS.RISE': "View and edit RISE team's SCS test keys",
    'Application.RISE.Operations.Users.SCS.RL': "View and edit RISE team's RL test keys",
    'Application.RISE.Operations.Users.SCS.SFS': "View and edit SFS team's SCS test keys",
    'Application.RISE.Operations.Users.SCS.SIM': "View and edit SIM team's SCS test keys",
  };

  return process.env.NODE_ENV.toLowerCase() === 'production' ? productionUsages : testUsages;
};

// Backward compatibility: export the subgroup usages for the current environment
export const subGroupUsages = getSubGroupUsages();

export const doNotShowTheseGroups = [
  'Application.RISE.AdminUI.Owner',
  'Application.RISE.AdminUI.Users.SLS.JustEnough',
  'Application.RISE.AdminUI.Users.SLS.IslandPacific',
  'App.RetailOperations.Users.RLT.ReadOnly',
];

export const readOnlyAlternativeGroups = {
  'App.RetailOperations.Users.RLT': 'App.RetailOperations.Users.RLT.ReadOnly',
};

export const getReadOnlyAlternativeGroups = (auth) => {
  const currentPermissions = getPermissionsToGroups();
  return readOnlyAlternativeGroups[currentPermissions[auth]];
};

// Permission values are either a single AD group string, or an array of equivalent
// AD groups (any-of-N) when multiple groups should grant the same tab access.
const getGroupsToPermissions = () => {
  const permissions = getPermissionsToGroups();
  return Object.entries(permissions).reduce((acc, [key, value]) => {
    const groups = Array.isArray(value) ? value : [value];
    groups.forEach((group) => {
      acc[group] = acc[group] ? acc[group].concat(key) : [key];
    });
    return acc;
  }, {});
};

// making the array out of a spread Set from the array just removes duplicates, otherwise this is just finding all groups that start with your group name + '.'
export const getSubGroups = (permission) => {
  const currentPermissions = getPermissionsToGroups();
  return [...new Set(
    Object.entries(currentPermissions)
      .filter(([key]) => key.startsWith(`${permission}.`))
      .flatMap(([, group]) => (Array.isArray(group) ? group : [group])),
  )];
};

export const getUserPermissions = (userGroups) => {
  let currentUserReq;
  const userPermissions = [];
  const groupsToPermissions = getGroupsToPermissions();

  // get the temp user if we're in dev mode
  if (process.env.NODE_ENV === 'development') {
    currentUserReq = frameUser;
  } else {
    currentUserReq = userGroups;
  }

  // add to body object for each group
  currentUserReq.forEach((group) => {
    try {
      userPermissions.push(...groupsToPermissions[group]);
    } catch {
      // ignore groups that we don't support mappings for
    }
  });
  return userPermissions;
};

export const isUserAllowed = (userGroups = [], group = 'Users') => getUserPermissions(userGroups).includes(group);

export const isUserReadOnly = (userGroups = [], groups) => userGroups.length === 2 && groups.every((reqGroup) => getUserPermissions(userGroups).includes(reqGroup));
